import {css} from "@emotion/react";
import classNames from "classnames";

import {CheckIcon} from "@pg-design/icons-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

interface IProps {
    isActive: boolean;
    position: number;
}

export const ForYouModalStepPoint = (props: IProps) => {
    return (
        <Text variant="headline_6" as="p" className={classNames(props.isActive && "active-step")} css={numberStyle}>
            {props.position}
        </Text>
    );
};

export const CompletedStepPoint = () => {
    const {isMobile} = useUserDevice();
    return <CheckIcon size="2" wrapperSize={isMobile ? "3.3" : "4.4"} wrapperColor={getThemeVariable("colors.success")} />;
};

const numberStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 33px;
    height: 33px;
    border: 1px solid ${getThemeVariable("colors.gray.400")};
    background-color: ${getThemeVariable("colors.gray.200")};

    @media (min-width: ${getThemeBreakpoint().md}) {
        width: 44px;
        height: 44px;
    }
`;
import {css} from "@emotion/react";
import classNames from "classnames";

import {CheckIcon} from "@pg-design/icons-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

interface IProps {
    isActive: boolean;
    position: number;
}

export const ForYouModalStepPoint = (props: IProps) => {
    return (
        <Text variant="headline_6" as="p" className={classNames(props.isActive && "active-step")} css={numberStyle}>
            {props.position}
        </Text>
    );
};

export const CompletedStepPoint = () => {
    const {isMobile} = useUserDevice();
    return <CheckIcon size="2" wrapperSize={isMobile ? "3.3" : "4.4"} wrapperColor={getThemeVariable("colors.success")} />;
};

const numberStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 33px;
    height: 33px;
    border: 1px solid ${getThemeVariable("colors.gray.400")};
    background-color: ${getThemeVariable("colors.gray.200")};

    @media (min-width: ${getThemeBreakpoint().md}) {
        width: 44px;
        height: 44px;
    }
`;
